import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddVatTuItems = _resolveComponent("AddVatTuItems")!
  const _component_BienBanKiemNghiemPrintModal = _resolveComponent("BienBanKiemNghiemPrintModal")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_Can = _resolveComponent("Can")!
  const _component_DetailTopicLottie = _resolveComponent("DetailTopicLottie")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_ResponsiveLayout = _resolveComponent("ResponsiveLayout")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_FilterItem = _resolveComponent("FilterItem")!
  const _component_FilterContainer = _resolveComponent("FilterContainer")!
  const _component_HopDongVatTuTable = _resolveComponent("HopDongVatTuTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BienBanKiemNghiemTable = _resolveComponent("BienBanKiemNghiemTable")!
  const _component_PhieuNhapKhoTableV2 = _resolveComponent("PhieuNhapKhoTableV2")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AddVatTuItems, {
      "is-modal-open": _ctx.isAddVatTuModalDisplay,
      "use-for": _ctx.AddVatTuItemsFor.HOP_DONG,
      "hop-dong-id": _ctx.hopDongId,
      "vat-tu-da-chon-items": _ctx.hopDongVatTuItems,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isAddVatTuModalDisplay = false)),
      onAdded: _ctx.onAddedVatTuItems
    }, null, 8, ["is-modal-open", "use-for", "hop-dong-id", "vat-tu-da-chon-items", "onAdded"]),
    _createVNode(_component_BienBanKiemNghiemPrintModal, {
      bienBanData: _ctx.openingBienBan,
      "hop-dong-data": _ctx.hopDong,
      "is-modal-open": _ctx.isBienBanModalDisplay,
      onOnCloseModal: _ctx.onCloseBienBanPrintModal
    }, null, 8, ["bienBanData", "hop-dong-data", "is-modal-open", "onOnCloseModal"]),
    _createVNode(_component_PageContentBase, { plain: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_PageContentSection, null, {
          header: _withCtx(() => [
            _createTextVNode(" Thông tin ")
          ]),
          actions: _withCtx(() => [
            _createVNode(_component_ButtonCustom, {
              "button-type": _ctx.ButtonsType.PRINT,
              "tooltip-message": "In chi tiết h/đồng",
              onClick: _ctx.openHopDongPdfViewer
            }, null, 8, ["button-type", "onClick"]),
            _createVNode(_component_Can, {
              all: [_ctx.HOP_DONG.SUA]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ButtonCustom, {
                  "button-type": _ctx.ButtonsType.EDIT,
                  "color-type": _ctx.ButtonTypeColors.SUCCESS,
                  "tooltip-message": "Chỉnh sửa h/đồng",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.push(`/quan-ly/hop-dong/cap-nhat/${_ctx.hopDongId}`)))
                }, null, 8, ["button-type", "color-type"])
              ]),
              _: 1
            }, 8, ["all"]),
            _createVNode(_component_Can, {
              all: [_ctx.HOP_DONG.XOA]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ButtonCustom, {
                  "button-type": _ctx.ButtonsType.TRASH,
                  "color-type": _ctx.ButtonTypeColors.DANGER,
                  "tooltip-message": "Xoá",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDeleteButtonClick()))
                }, null, 8, ["button-type", "color-type"])
              ]),
              _: 1
            }, 8, ["all"])
          ]),
          illustration: _withCtx(() => [
            _createVNode(_component_DetailTopicLottie, { topic: "hop-dong" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                  default: _withCtx(() => [
                    _createTextVNode("ID:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.hopDongId), 1)
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                  default: _withCtx(() => [
                    _createTextVNode("Hoàn thành")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  id: "is-hoan-thanh",
                  "model-value": _ctx.isHoanThanh,
                  disabled: "",
                  size: "large"
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                  default: _withCtx(() => [
                    _createTextVNode("Mã hợp đồng:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.hopDong?.so_hop_dong || "-"), 1)
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                  default: _withCtx(() => [
                    _createTextVNode("Loại HĐ:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.loaiHopDongDisplay), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                  default: _withCtx(() => [
                    _createTextVNode("Số hoá đơn:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.hopDong?.so_hoa_don ?? "-"), 1)
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                  default: _withCtx(() => [
                    _createTextVNode("Mã số thuế:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.hopDong?.ma_so_thue), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                  default: _withCtx(() => [
                    _createTextVNode("Tên đối tác:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.hopDong?.ten_doi_tac ?? "-"), 1)
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                  default: _withCtx(() => [
                    _createTextVNode("Số điện thoại:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.hopDong?.so_dien_thoai || "-"), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ngày ký:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.hopDong?.ngay_ky).format("DD/MM/YYYY")), 1)
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ngày hết hạn:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(_component_el_tag, {
                  class: _normalizeClass(["fw-bolder", {
              'text-success':
                (!_ctx.isHopDongHetHan && _ctx.hopDong?.ngay_het_han) ||
                !_ctx.hopDong?.ngay_het_han,
              'text-danger': _ctx.isHopDongHetHan,
            }])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.hopDong?.ngay_het_han
                ? _ctx.formatDate(_ctx.hopDong.ngay_het_han).format("DD/MM/YYYY")
                : "Vô thời hạn"), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ngày tạo:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.hopDong?.created_at).format("DD/MM/YYYY")), 1)
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cập nhật lần cuối:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.hopDong?.updated_at
                ? _ctx.formatDate(_ctx.hopDong.updated_at).format("DD/MM/YYYY")
                : "-"), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                  default: _withCtx(() => [
                    _createTextVNode("Địa chỉ:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.hopDong?.dia_chi), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_PageContentSection, null, {
          header: _withCtx(() => [
            _createTextVNode(" Vật tư ")
          ]),
          actions: _withCtx(() => [
            (_ctx.hopDong?.bien_ban_kiem_nghiem.length === 0)
              ? (_openBlock(), _createBlock(_component_Can, {
                  key: 0,
                  all: [_ctx.HOP_DONG.SUA]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ButtonCustom, {
                      "button-type": _ctx.ButtonsType.ADD,
                      "color-type": _ctx.ButtonTypeColors.SUCCESS,
                      "tooltip-message": "Thêm v/tư",
                      onClick: _ctx.onAddVatTuButtonClicked
                    }, null, 8, ["button-type", "color-type", "onClick"])
                  ]),
                  _: 1
                }, 8, ["all"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_FilterContainer, null, {
              default: _withCtx(() => [
                _createVNode(_component_FilterItem, { label: "Tìm kiếm" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.searchTerm,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchTerm) = $event)),
                      style: {"width":"20rem"},
                      placeholder: "Tìm theo mã hoặc tên",
                      onInput: _ctx.searchForVatTuHopDong
                    }, null, 8, ["modelValue", "onInput"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.hopDong)
              ? (_openBlock(), _createBlock(_component_HopDongVatTuTable, {
                  key: 0,
                  "is-loading": _ctx.isLoading,
                  "cur-page": _ctx.currentPage,
                  "per-page": _ctx.perPage,
                  items: _ctx.hopDongVatTuItems
                }, null, 8, ["is-loading", "cur-page", "per-page", "items"]))
              : _createCommentVNode("", true),
            (_ctx.hopDongVatTuItems.length > 0)
              ? (_openBlock(), _createBlock(_component_Pagination, {
                  key: 1,
                  page: _ctx.currentPage,
                  "page-size": _ctx.perPage,
                  total: _ctx.totalItems,
                  onChangePage: _cache[4] || (_cache[4] = (value) => (_ctx.currentPage = value)),
                  onChangePageSize: _cache[5] || (_cache[5] = (value) => (_ctx.perPage = value))
                }, null, 8, ["page", "page-size", "total"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_PageContentSection, null, {
          header: _withCtx(() => [
            _createTextVNode(" Biên bản kiểm nghiệm ")
          ]),
          actions: _withCtx(() => [
            (!_ctx.isHoanThanh && !_ctx.isHopDongHetHan && _ctx.hopDongVatTuItems.length)
              ? (_openBlock(), _createBlock(_component_Can, {
                  key: 0,
                  all: [_ctx.PHIEU_NHAP_KHO.TAO_MOI]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_RouterLink, {
                      target: "_blank",
                      to: {
              name: 'tao-moi-phieu-nhap-kho',
              query: {
                idHopDong: String(_ctx.hopDongId),
              },
            }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ButtonCustom, {
                          "button-type": _ctx.ButtonsType.ADD,
                          "color-type": _ctx.ButtonTypeColors.SUCCESS,
                          "tooltip-message": "Tạo BBKN"
                        }, null, 8, ["button-type", "color-type"])
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                }, 8, ["all"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            (_ctx.hopDong)
              ? (_openBlock(), _createBlock(_component_BienBanKiemNghiemTable, {
                  key: 0,
                  "hop-dong-data": _ctx.hopDong,
                  items: _ctx.hopDong.bien_ban_kiem_nghiem,
                  onOnDetailButtonClick: _ctx.onBienBanDetailButtonClicked
                }, null, 8, ["hop-dong-data", "items", "onOnDetailButtonClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_PageContentSection, null, {
          header: _withCtx(() => [
            _createTextVNode(" Phiếu nhập kho ")
          ]),
          default: _withCtx(() => [
            (_ctx.hopDong)
              ? (_openBlock(), _createBlock(_component_PhieuNhapKhoTableV2, {
                  key: 0,
                  items: _ctx.phieuNhapKhoItems,
                  "cur-page": 1,
                  "per-page": 10,
                  "id-kho": 0,
                  "show-kho-column": true,
                  "show-xac-nhan-button": true,
                  "show-delete-button": true,
                  "show-edit-button": true,
                  onOnDetailButtonClick: _ctx.onPhieuNhapDetailButtonClicked,
                  onRefresh: _ctx.fetchData
                }, null, 8, ["items", "onOnDetailButtonClick", "onRefresh"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}